
import { Box, Button, Container, Dialog } from "@mui/material"
import Cafgu from '../../../../assets/images/core/cafgu.png';
import WelcomeCafgu from '../../../../assets/images/core/welcome-cafgu.svg';
import { PostPersonalization } from "../global/Index";

export const Welcome = ({welcome, userId, tour}) => {
    const handlerStart = async() => {
        const body = {
            user_id: userId.data,
            feature_name: 'welcomepage',
            personalization:[
                {p_name: 'welcome', status: 1}, {p_name: 'onboarding' , status: 0}
            ]
        }
        const res = await PostPersonalization({body: body})
        if (res.msg === 'success') {
            welcome.set({start: false, features: true})
            // tour.set(true)
        }
        // if (userId.data === 0) {
        //     const data =  {feature_name: 'welcomepage', personalization:[
        //         {p_name: 'welcome', status: 1}, {p_name: 'onboarding' , status: 0}
        //     ]}
        //     insertData('personalization', 'welcome', data)
        //     welcome.set({start: false, features: true})
        // }else{
        //     const body = {
        //         user_id: userId.data,
        //         feature_name: 'welcomepage',
        //         personalization:[
        //             {p_name: 'welcome', status: 1}, {p_name: 'onboarding' , status: 0}
        //         ]
        //     }
        //     const res = await PostPersonalization({body: body})
        //     if (res.msg === 'success') {
        //         tour.set(true)
        //     }
        // }
    }
    
    return (
         <Dialog open={welcome.data.start} fullScreen>
            <Container
                    maxWidth={false}
                    disableGutters
                    sx={{
                        minHeight: "100vh",          // full screen height
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        backgroundColor: "#f5f5f5",  // optional background
                    }}
            >
                <Box display="flex" flexDirection="column" gap="24px" p={3}>
                    <Box display="flex" justifyContent="center">
                        <img src={Cafgu} alt="cafgu" width={150} height={150}/>
                    </Box>
                    <Box textAlign="center" >
                        <Box fontWeight="bold" textAlign="center" fontSize={24}>Welcome to SHOP!</Box>
                        <Box fontSize={14} color="#8F8F8F">is a one stop app for your needs, from product to services and more.</Box>
                    </Box>
                    <Box display="flex" justifyContent="center" gap="8px">
                        <Box component={Button} variant="contained" mt="12px" onClick={handlerStart} fullWidth>
                            Let's Start
                        </Box>
                    </Box>
                </Box>
            </Container>
         </Dialog>
    )
}

export const WelcomeFeature = ({welcome, tour, handlerSkipGotIt}) => {
    const handlerBtns = async(action) => {
        if (action === 'skip') {
            await handlerSkipGotIt('', 'skip')
            welcome.set({start: false, features: false})
        }else{
            welcome.set({start: false, features: false})
            tour.set(true)
        }
    }
    return(
        <Dialog open={welcome.data.features} PaperProps={{ sx: { borderRadius: '16px' } }} >
             <Box maxWidth={{xs:'100%', sm:420}}>
                <img src={WelcomeCafgu} alt="cafgu-img" width="100%" height="100%" />
                <Box display="flex" flexDirection="column" gap="24px" p={3}>
                    <Box fontWeight="bold" textAlign="center">Let me show you some great features of SHOP!</Box>
                    <Box display="flex" justifyContent="center" gap="8px">
                        <Box component={Button} variant="outlined" mt="12px" onClick={() => handlerBtns('skip')} fullWidth>
                            Skip
                        </Box>
                        <Box component={Button} variant="contained" mt="12px" onClick={() => handlerBtns('proceed')} fullWidth>
                            Proceed
                        </Box>
                    </Box>
                </Box>
             </Box>
        </Dialog>
    )
}